import { CUSTOMER_JOURNEY_RESERVATION } from './../const';

function action(token, lang, context) {
  return { type: CUSTOMER_JOURNEY_RESERVATION, token, lang, context };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyReservation.js